<template>
  <v-container fluid>
    <v-card class="ma-3">
    <v-card-title>
      <h1 class="mr-2 subheading grey--text">Στατιστικά Στοιχεία</h1>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-alert type="info" dense>
              Τα στατιστικά στοιχεία αφορούν τις τελευταίες 365 ημέρες.
            </v-alert>
          </v-col>
        </v-row>

        <!-- First Row: Total Sold, Turnover, DSI, Average Inventory -->
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="metrics.TotalSold"
              label="Σύνολο πωληθέντων"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="metrics.Turnover"
              label="Κίνηση αποθήκης"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="metrics.Dsi"
              label="Ημέρες αποθέματος"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="metrics.AvgInventory"
              label="Μέσο Απόθεμα"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <!-- Second Row: Stock Qty, Inventory Cost, Orders Value -->
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="part.StockQty"
              label="Απόθεμα αποθήκης"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="formattedMetrics.InventoryCost"
              label="Κόστος Αποθήκης"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="formattedMetrics.OrdersValue"
              label="Κόστος Παραγγελιών"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <!-- Third Row: Remaining Financial Data -->
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="formattedMetrics.TotalCogs"
              label="Kόστος Πωλήσεων"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="formattedMetrics.TotalProfit"
              label="Συνολικό Κέρδος"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="formattedMetrics.TotalSales"
              label="Σύνολο Πωλήσεων"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>

    <v-card class="d-flex-column justify-space-between ma-3" id="part-details">
<!--      <v-breadcrumbs :items="quote.versions">
         <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        :href="item"
      >
        {{ item.toUpperCase() }}
      </v-breadcrumbs-item>
      </template>
      </v-breadcrumbs>
-->
    <v-card-title> Στοιχεία Ανταλλακτικού </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          :valid="valid"
        >
        <v-row>
          <!-- <v-col cols=2 sm=2 md=2>
          <v-text-field
          label="Αρ. Επισκευής"
          v-model="part.Id"
          prepend-icon="mdi-counter"
            >
          </v-text-field>
          </v-col>
            <v-col cols=12 sm=4 md=3>
          <v-text-field
            v-model="part.Description"
            readonly
            label="Όχημα"
            >
             <template v-slot:append>
              <v-btn icon @click="vehicleDetails"><v-icon>mdi-information</v-icon></v-btn>
            </template>
          </v-text-field>
          </v-col>

        </v-row>
        <v-row>
          <v-col cols=12 md=6>
          <v-text-field
            v-model="part.FmSku"
            prepend-icon="mdi-counter"
            readonly
            label="Πελάτης"
            >
            <template v-slot:append>
              <v-btn icon @click="accountPage"><v-icon>mdi-information</v-icon></v-btn>
            </template>
            </v-text-field>

            </v-col>
            </v-row>
            <v-row> -->
          <v-col cols=12 md=6>
          <v-textarea
            v-model="part.Notes"
            prepend-icon="mdi-notebook"
            rows="1"
            :auto-grow=true
            label="Σημειώσεις"
            hint="Αριθμός πλαισίου, όχημα, κλπ"
            >
         </v-textarea>
          </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
      <v-speed-dial
      v-model="fab"
      top
      right
      direction="left"
      absolute
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="blue darken-2"
          dark
          fab
        >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="updateNotes">
              <v-icon dark>mdi-content-save</v-icon>
            </v-btn>
             <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="getPDF"
              >
              <v-icon dark>mdi-file-pdf-box</v-icon>
            </v-btn>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="invoice">
              <v-icon dark>mdi-printer-pos</v-icon>
            </v-btn>
        </v-speed-dial>
      </v-card-actions>
    </v-card>

    <v-card class="ma-3 mt-10" id="item-list" >
      <v-card-title>Λίστα Ιδιοτητων<v-spacer/>
          <v-toolbar flat height="40px"  color="white">
            <div class="d-flex w-200">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" dense outlined single-line hide-details></v-text-field>
            <v-dialog
                v-model="dialog"
                persistent
                max-width="600px"
              >
                <template v-slot:activator="{on, attrs}">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2 white--text">
                      <v-icon dark>mdi-plus</v-icon>Ιδιότητα
                    </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="part">
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm=8
                          md=8
                          xs=12
                        >
                          <v-text-field
                            label="Περιγραφή*"
                            :rules="[rules.required]"
                            v-model="editedItem.Text"
                            required
                            dense
                            ></v-text-field>
                        </v-col>
                      <v-col cols="6" sm="6" md=4>
                          <v-text-field
                            label="Τιμή*"
                            :rules="[rules.required]"
                            v-model="editedItem.Value"
                            dense
                            required
                            ></v-text-field>

                      </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="close"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                    >
                      Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
              <v-spacer/>
            </v-toolbar>
      </v-card-title>
      <v-card-text>
      <v-data-table
        :headers="showHeaders"
        :items="partDetails"
        item-key="itemId"
        :search="search"
        :item-class="rowClass"
        class="elevation-0"
        height="600px"
        mobile-breakpoint=800
        dense
        fixed-header>

        <v-divider inset></v-divider>
        <template v-slot:top>
          </template>

        <template v-slot:item.index="{ item }">
          <span>{{partDetails.indexOf(item)+1}}</span>
        </template>
        <template v-slot:item.Status="{ item }">
          <span>{{ getStatus(item.Status) }}</span>
        </template>
         <template v-slot:item.TechId="{ item }">
          <span>{{ technicians[item.TechId-1].Name }}</span>
        </template>
        <template v-slot:item.vat="{ item }">
          <span v-if="isNaN(item.Price)"></span>
            <span v-else>{{ tocurr(item.Qty*item.Price*0.24)}}</span>
        </template>
        <template v-slot:item.gross="{ item }">
          <span v-if="isNaN(item.Price)"></span>
            <span v-else>{{ tocurr(item.Qty*item.Price)}}</span>
        </template>
        <template v-slot:item.Value="{ item }">
          <span v-if="item.Text=='κωδικός Inter Cars'">
          <a v-bind:href="`https://gr.e-cat.intercars.eu/el/%CE%A0%CE%BB%CE%AE%CF%81%CE%B7%CF%82-%CF%80%CF%81%CE%BF%CF%83%CF%86%CE%BF%CF%81%CE%AC/c/tecdoc?q=${item.Value}%3Adefault&initialSearch=true`">{{ item.Value }}</a>
          </span>
            <span v-else>{{ item.Value }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div>
            <v-icon class="mr-3" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon class="mr-3" @click="copyItem(item)">
              mdi-content-copy
            </v-icon>
            <v-icon @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </div>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
//const _ = require("lodash");


// import filter from "lodash/filter";

export default {
  props: {
    //partDetails: []
  },
  computed: {
    pdfPath () {
        return `${this.$api.defaults.baseURL}/parts/${this.part.Id}/card/`;
    },
    showHeaders() {
        if (this.$vuetify.breakpoint.smAndDown) {
            return this.headers.filter(h => !(["vat", "Status", "value", "TechId"]).includes(h.value));
        } else {
            return this.headers;
        }
    },
    formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },

    formattedMetrics() {
      return {
        ...this.metrics,
        TotalCogs: this.formatCurrency(this.metrics.TotalCogs),
        TotalProfit: this.formatCurrency(this.metrics.TotalProfit),
        TotalSales: this.formatCurrency(this.metrics.TotalSales),
        OrdersValue: this.formatCurrency(this.metrics.OrdersValue),
        InventoryCost: this.formatCurrency(this.metrics.InventoryCost),
      };
    },
  },

  data () {
    return {
    menu: false,
    fab: false,
    valid: true,
    dialog: false,
    part: {},
    technicians: {},
    rules: {
        required: value => !!value || 'Required.',
    },
    search: '',
    headers: [
      {
        text: 'Α/Α',
        value: 'itemId',
        sortable: true,
        width: '2%'
      },
      {
        text: 'Περιγραφή',
        value: 'Text',
        sortable: true,
        width: '45%'
      },
      {
        text: 'Ποσότητα',
        value: 'Value',
        sortable: false,
        width: '25%'
      },
      { text: 'Actions', value: 'actions', align: 'end', sortable: false , width: "150px"},
    ],
    partDetails: [],
    statuses: [
      {value: -1, text: "Εκκρεμεί"},
      {value: 1, text: "Επισκευασμένο"},
      {value: 0, text: "Τιμολογημένο"},
      {value: -2, text: "Εξοφλημένο"},
     ]
      ,
    editedIndex: -1,
    editedItem: {
      itemId: 0,
      Text: '',
      Value: 1,
    },
    defaultItem: {
      itemId: 0,
      Text: '',
      Value: '',
    },
    metrics: {
        TotalSold: 0,
        Turnover: 0,
        Dsi: 0,
        TotalCogs: 0,
        TotalProfit: 0,
        TotalSales: 0,
        OrdersValue: 0,
        InventoryCost: 0,
        AvgInventory: 0,
      },
    }
  },
  async created () {
      this.initialize();
  },

  methods: {
   accountPage() {
        let path = "customer-info"
        let params = {"id": this.part.Vehicle.Owner.Id}
        if (this.part.Vehicle.Owner.Cid.startsWith("G")) {
              path = 'book-info';
        }

        this.$router.push({"name": path, "params": params});
    },
    vehicleDetails() {
        let path = "Vehicle"
        let params = {"vehicle": this.part.VehId}
        this.$router.push({"name": path, "params": params});
    },
    sumTotals(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b.Price*b.Qty || 0), 0);
    },
    async updateNotes () {
        await this.$api.patch("/parts/"+this.$route.params.partId, {Notes: this.part.Notes});
    },
    async invoice () {
        const response = await this.$api.patch("/parts/invoice/"+this.$route.params.partId);
        if (response.status == 202) {
              this.part = response.data;
              this.partDetails = [];
              let j = 1;
              for (var value of this.part.Items) {
                value.itemId = j;
                this.partDetails.push(value);
                j +=1;
              }
        }
    },
    async getPDF () {
        const response = await this.$api.get(`/parts/${this.part.Id}/card`);
        window.open(`${this.$api.defaults.baseURL}/parts/card/${response.data}`, '_blank');
    },
    rowClass (item) {
      return this.partDetails.indexOf(item) %2 ? 'blue-grey lighten-5' : 'white darken-2';
    },
    async initialize () {
      const response = await this.$api.get("/inventory/parts/info/" + this.$route.params.id, {cache: {maxAge: 30*1000}});
      this.part = response.data;
      await this.fetchInventoryMetrics();
      let j = 1;
      for (var value of this.part.PartProperties) {
        value.itemId = j;
        this.partDetails.push(value);
        j +=1;
      }

      // console.log(this.quote);

    },
    copyItem (item) {
      const addObj = Object.assign({}, item);
      addObj.itemId = this.partDetails.length + 1;
      this.partDetails.unshift(addObj);
    },
    editItem (item) {
      this.editedIndex = this.partDetails.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    async deleteItem (item) {
      const index = this.partDetails.indexOf(item);
      if (confirm('Are you sure you want to delete this item?')) {
              this.partDetails.splice(index, 1);
          }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300)
    },
    addNew() {
       const addObj = Object.assign({}, this.defaultItem);
       addObj.itemId = this.partDetails.length + 1;
       this.partDetails.unshift(addObj);
       this.editItem(addObj);
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.partDetails[this.editedIndex], this.editedItem);
        // this.patchPartItem(this.editedIndex);
      } else{
        this.partDetails.push(this.editedItem);
       // this.patchPartItem(-1);
      }
      this.close()
    },
    async patchPartItem(itemIndex) {
      let item = this.partDetails.at(itemIndex);
      item.PartId = this.$route.params.partId

      if (item.Id) {
        const response = await this.$api.patch("/parts/items/"+item.Id, item)
          //console.log(response);
          item.Sku = response.data.Sku;
          item.Description = response.data.Description;

      } else {
        const response = await this.$api.post("/parts/items/", item)
          console.log(response);
        item.Id = response.data.Id;

      }
    },
    async fetchInventoryMetrics() {
        try {
          const metricsResponse = await this.$api.get(`/inventory/parts/metrics/${this.$route.params.id}`);
          this.metrics = metricsResponse.data;
        } catch (error) {
          console.error(error);
        }
     },

     formatCurrency(value) {
      return new Intl.NumberFormat('el-GR', {
        style: 'currency',
        currency: 'EUR',
      }).format(value);
    },
  },
  }
</script>

<style>
.row-odd {
  background-color: orange;
}
.row-even {
  background-color: "red";
}
</style>
